import { AddPhotoAlternate } from "@mui/icons-material";
import {
  doc,
  getDoc,
  serverTimestamp,
  setDoc,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import React, { useContext, useState } from "react";
import { v4 as uuid } from "uuid";
import { AuthContext } from "../../context/AuthContext";
import { ChatContext } from "../../context/ChatContext";
import { db, storage } from "../../firebase";
import Search from "../general/Search";

export default function Modal({ setToggleGroup, members, setMembers }) {
  const [error, setError] = useState(false);
  const [group, setGroup] = useState();
  const [avatar, setAvatar] = useState("");
  const { dispatch } = useContext(ChatContext);
  const { currentUser, currentUserData } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const uploadImg = async (displayName, file) => {
    const storageRef = ref(storage, displayName);
    let res = await uploadBytesResumable(storageRef, file);
    console.log(res);
    if (res.state === "success") {
      let downloadURL = await getDownloadURL(res.ref);
      return downloadURL;
    } else {
      return "";
    }
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    const fileUrl = URL.createObjectURL(file);
    setAvatar(fileUrl);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (members.length === 0) return alert("Members cannot be 0");
    setLoading(true);
    const displayName = e.target[0].value;
    const file = e.target[1].files[0];
    let downloadURL = await uploadImg(displayName, file);
    let groupId = uuid();
    await createChat(currentUser.uid, groupId, displayName, downloadURL);
    for (let i = 0; i < members.length; i++) {
      let user_id = members[i].uid;
      createChat(user_id, groupId, displayName, downloadURL);
    }
    let query = [];
    let currentQuery = "";
    for (let index = 0; index < displayName.length; index++) {
      const element = displayName[index];
      currentQuery += element;
      query.push(currentQuery.toLowerCase());
    }
    let membersAll = [...members, currentUserData];
    console.log("sadds", currentUserData);
    //create group on firestore
    await setDoc(doc(db, "groups", groupId), {
      uid: groupId,
      displayName,
      photoURL: downloadURL,
      ownerId: currentUser.uid,
      date: Timestamp.now(),
      photoURL: downloadURL,
      members: membersAll,
      query,
    });
    setLoading(false);
    setToggleGroup(false);
  };

  const createChat = async (userID, groupID, displayName, downloadURL) => {
    const userChats = await getDoc(doc(db, "userChats", userID));
    if (!userChats.exists()) {
      await setDoc(doc(db, "userChats", userID), {
        [groupID]: {
          groupInfo: {
            uid: groupID,
            displayName,
            photoURL: downloadURL,
          },
          date: serverTimestamp(),
        },
      });
    } else {
      await updateDoc(doc(db, "userChats", userID), {
        [groupID]: {
          groupInfo: {
            uid: groupID,
            displayName,
            photoURL: downloadURL,
          },
          date: serverTimestamp(),
        },
      });
    }
  };
  return (
    <div className="formContainer" onClick={() => setToggleGroup(false)}>
      <div
        className="formWrapper"
        onClick={(e) => {
          // do not close modal if anything inside modal content is clicked
          e.stopPropagation();
        }}
      >
        <span className="title">Create New Group+</span>
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="Group name" required />
          <input
            type="file"
            id="file"
            accept="image/jpeg, image/png"
            style={{ display: "none" }}
            onChange={handleAvatarChange}
          />
          <label htmlFor="file">
            {avatar ? (
              <img
                src={avatar}
                alt="avatar"
                height={30}
                width={30}
                style={{
                  borderRadius: "4px",
                  border: "1px solid black",
                  objectFit: "cover",
                  marginRight: "5px",
                }}
              />
            ) : (
              <AddPhotoAlternate className="icon" />
            )}
            {avatar ? "Change avatar" : "Add an avatar"}
          </label>
          <Search
            className="memberSearch"
            placeholder="add a member"
            group={true}
            members={members}
            setMembers={setMembers}
          />
          <button type="submit">{loading ? "Creating..." : "Create"}</button>
        </form>
        {/* {error && <span className="alert">Something went wrong!</span>} */}
      </div>
    </div>
  );
}
